import {
  // -- GET (list)
  GET_SCENARIO_RESOURCES_SUCCESS,
  GET_SCENARIO_RESOURCES_FAILURE,
  // -- CREATE
  CREATE_SCENARIO_RESOURCE_SUCCESS,
  CREATE_SCENARIO_RESOURCE_FAILURE,
  // -- UPDATE
  UPDATE_SCENARIO_RESOURCE_SUCCESS,
  UPDATE_SCENARIO_RESOURCE_FAILURE,
  // -- DELETE
  DELETE_SCENARIO_RESOURCE_SUCCESS,
  DELETE_SCENARIO_RESOURCE_FAILURE,
  // -- SEARCH
  SEARCH_SCENARIO_RESOURCES
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const scenarioResources = (state = {}, action) => {
  switch (action.type) {
    // -- GET SCENARIO RESOURCES (list)
    case GET_SCENARIO_RESOURCES_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioResources.GET_SCENARIO_RESOURCES_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_SCENARIO_RESOURCES_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioResources.GET_SCENARIO_RESOURCES_SUCCESS()', {
        state,
        action
      })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE SCENARIO RESOURCE
    case CREATE_SCENARIO_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioResources.CREATE_SCENARIO_RESOURCE_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case CREATE_SCENARIO_RESOURCE_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioResources.CREATE_SCENARIO_RESOURCE_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE SCENARIO RESOURCE
    case UPDATE_SCENARIO_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioResources.UPDATE_SCENARIO_RESOURCE_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case UPDATE_SCENARIO_RESOURCE_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioResources.UPDATE_SCENARIO_RESOURCE_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE SCENARIO RESOURCE
    case DELETE_SCENARIO_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioResources.DELETE_SCENARIO_RESOURCE_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case DELETE_SCENARIO_RESOURCE_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioResources.DELETE_SCENARIO_RESOURCE_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH SCENARIO
    case SEARCH_SCENARIO_RESOURCES: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
